import { FC } from "react"
import { Link } from "react-router-dom";
import { PROVIDER_PRACTICES_HEADER } from "src/constants/manufacturer";
import { providerProps } from "./types";
import { objectToQueryString } from "src/helpers";


const CustomProviderPractice: FC<providerProps> = ({ providerPracticesList,title,queryParam }): JSX.Element => {

  return (
    <div className="card flex-fill mt-3">
      <div className="d-flex flex-column flex-fill">
        <div className="card-header order-1 custom-card-header">
          <h4 className="mb-0 p-0 text-white text-center " >{title}</h4>
        </div>
        <div className="order-2 card-body p-0 overflow-y-auto" style={{ maxHeight: 350 }}>
          <table className="table table-responsive table-hover">
            <thead className="table-light thead-sticky">
              <tr>
              {PROVIDER_PRACTICES_HEADER.map((tableHeader, index) => (
                    <th key={index} className="text-center top-0" scope="col">
                      <span
                        role={tableHeader.value === '' ? "textbox" : "button"}
                        className={
                          tableHeader.value === '' ?
                            'fw-bold fs-6 lh-base' :
                            'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                        }
                      >
                        {tableHeader.label}
                      </span>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {providerPracticesList && providerPracticesList.result.length>0 &&
                providerPracticesList.result.map((item:any,key:any) =>
                  <tr key={key} className="align-middle">
                    <td className="text-center">
                      <Link to={{ pathname: '/doctor/stats',
                             search: objectToQueryString({
                              search_str: item.doctor_id,
                              type:"doctor",
                              id: item.doctor_id,
                              role: "doctor",
                              start_date:queryParam.start_date,
                              end_date : queryParam.end_date,
                              detail: true
                            } )
                      }}
                       className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover text-center" >
                        {item?.doctor_name}
                      </Link>
                    </td>
                    <td className="text-center"> {item.plan_type_data[0].count}</td>
                    <td className="text-center">{item.plan_type_data[1].count}</td>
                    <td className="text-center">{item?.plan_type_data[3].count}</td>
                    <td className="text-center">
                      {`${item?.plan_type_data[0].cases_total.split("  ")[0]} (${item?.plan_type_data[0].cases_total.split("  ")[1]} %)`}
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default CustomProviderPractice;
